import common from "./common/reducer";
import user from "./user/reducer";

export default {
  common: common,
  user: user,
};
